"use client";
import { Section } from "../ui/section";
import { useTranslation } from "@/lib/i18n";

const stats = (t: any) => [
    { value: "7+", label: t("stats.frameworks_supported") },
    { value: "500+", label: t("stats.documents_analyzed") },
    { value: "99.9%", label: t("stats.uptime_sla") },
    { value: "10x", label: t("stats.expert_support") },
];

export default function Stats() {
  const { t } = useTranslation("common");
    return (
        <Section>
            <div className="mx-auto flex max-w-container flex-col items-center gap-8 sm:gap-16">
                <div className="flex flex-col items-center gap-4 text-center">
                    <h2 className="max-w-[720px] text-3xl font-semibold leading-tight sm:text-5xl sm:leading-tight">
                        {t("stats.title")}
                    </h2>
                    <p className="text-md max-w-[600px] font-medium text-muted-foreground sm:text-xl">
                        {t("stats.subtitle")}
                    </p>
                </div>
                <div className="grid w-full max-w-[900px] grid-cols-2 gap-6 sm:grid-cols-4">
                    {stats(t).map((stat: any) => (
                        <div
                            key={stat.label}
                            className="flex flex-col items-center gap-2 rounded-xl glass-4 p-6 text-center transition-all hover:shadow-lg"
                        >
                            <span className="text-4xl font-bold text-aicompliance-foreground sm:text-5xl">
                                {stat.value}
                            </span>
                            <span className="text-sm font-medium text-muted-foreground">
                                {stat.label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
}
